

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">AREE TEMATICHE</a></span></li>
            <li class="last"><span><a href="/sirang/aria">ARIA</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column portlet-column-first" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_zROtZn5qjxGT_">
                     <span id="p_56_INSTANCE_zROtZn5qjxGT"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_zROtZn5qjxGT">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Aria ed Emissioni in Atmosfera</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> Il modulo <strong>Aria ed Emissioni in atmosfera</strong> ha lo scopo di supportare l'attività e le esigenze informative degli organi istituzionali preposti al controllo della qualità dell'aria. Poiché tali sorgenti sono essenzialmente di origine industriale o artigianale (es. camini etc.), la loro descrizione nel SIRA comprende anche informazioni relative all'insediamento produttivo/impianto in cui è ubi-cato il punto di emissione e quindi agli impianti soggetti ad AIA.</p>
                                       <p> Lo scopo primario del modulo è quello di divenire un importante strumento in grado di coadiuvare i diversi utenti preposti alla tutela dell'aria, alla protezione dall'inquinamento dell'atmosfera e alla specifica gestione dei stabilimenti soggetti ad AIA. In sintesi, l'assetto strutturale per quest'area tematica coadiuva i diversi utenti nell'istruire e condurre le pratiche relative all'iter tecnico-autorizzativo per le emissioni in atmosfera, per l'inventario dell'emissioni e per gli stabilimenti IPPC.</p>
                                       <p> Nell'ambito di quest'area tematica, per creare un ambiente omogeneo, funzionale e perfettamente integrato, è possibile la consultazione di diversi moduli applicativi che di seguito vengono riassunti:</p>
                                       <ul style="list-style-type:circle;">
                                          <li> Catasto delle sorgenti di emissioni in atmosfera comprendente i catasti delle emissioni lineari e areali,</li>
                                          <li> Catasto degli impianti IPPC comprendente il catasto degli impianti soggetti ad Autorizzazione Integrata Ambientale</li>
                                          <li> Inventario delle emissioni in atmosfera: dedicata alla elaborazione mediante metodologia CORINAR e alla trasposizione dei dati</li>
                                       </ul>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column portlet-column-last" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_ieAw63KB7TJL_">
                     <span id="p_56_INSTANCE_ieAw63KB7TJL"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_ieAw63KB7TJL">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Dati ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <a target="_blank" href="https://portal.sardegnasira.it/web/sardegnaambiente/dati-ambientali-qualita-aria">Vai alla pagina</a></li>
<!--
                                          <li> <u>RAS_Servizio tutela dell'atmosfera e del territorio </u></li>
                                          <li> <u>ARPA Sardegna</u></li>
                                          <li> <u>Pubbliche amministrazioni locali regional</u>i</li>
-->                                          
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
                  <!--
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_CyD7MHhuv94O_">
                     <span id="p_56_INSTANCE_CyD7MHhuv94O"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_CyD7MHhuv94O">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">temi</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <strong><u>Sorgenti di emissione in atmosfera</u></strong></li>
                                          <li> <strong><u>Inventario delle emissioni</u></strong></li>
                                          <li> <strong><u>Impianti IPPC</u></strong></li>
                                       </ul>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
-->
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>